(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password-content"]) return;
  try {
    
(() => {
  const layer = document.querySelector('.ev-sparkles');
  if (!layer || layer.dataset.ready) return;
  layer.dataset.ready = 'true';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let last = 0;
  const burst = () => {
    if (reduced.matches || document.hidden) return;
    const now = performance.now();
    if (now - last < 130) return;
    last = now;
    for (let i = 0; i < 3 && layer.childElementCount < 24; i++) {
      const star = document.createElement('span');
      star.className = 'ev-sparkle';
      star.style.left = (8 + Math.random() * 84) + '%';
      star.style.top = (10 + Math.random() * 80) + '%';
      layer.appendChild(star);
      window.setTimeout(() => star.remove(), 1100);
    }
  };
  window.addEventListener('scroll', burst, { passive: true });
  window.addEventListener('wheel', burst, { passive: true });
  window.addEventListener('touchmove', burst, { passive: true });
  burst();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-header"]) return;
  try {
    
(() => {
 const form = document.getElementById('EdelvintageLanguage');
 const select = form && form.querySelector('select[name="language_code"]');
 if (select && !select.dataset.ready) {
  select.dataset.ready = 'true';
  select.addEventListener('change', () => form.requestSubmit());
 }
})();

  } catch(e) { console.error(e); }
})();
})();
